import React from 'react';
import PropTypes from 'prop-types';

import {
	LibraryVideo,
	VideoFeed,
	useLibraryVideoContext,
} from '@techchange/video';

import { RESOURCE_VIDEO_PROVIDERS } from '../../utils/constants';
import { videoDataShape } from '../../utils/propTypes';
import { isSafeUrl } from '../../../../utils/urls';

const propTypes = {

	/**
	 * The unique ID for the content.
	 */
	id: PropTypes.string,

	/**
	 * Additional data for the content.
	 */
	data: PropTypes.shape(videoDataShape),

	/**
	 * The title to display.
	 */
	title: PropTypes.string,

	/**
	 * The current user's ID.
	 */
	userId: PropTypes.string,

	/**
	 * Flag indicating if the current user is an admin.
	 */
	isAdmin: PropTypes.bool,

	/**
	 * Flag indicating if the content title should be visible.
	 */
	showTitle: PropTypes.bool,

	/**
	 * Callback function to handle watching a video.
	 */
	onVideoWatch: PropTypes.func,

};

const ContentDisplay = (props) => {

	const {
		id,
		data,
		title,
		userId,
		isAdmin,
		showTitle,
		onVideoWatch,
	} = props;

	const { video, videoError, isLoading } = useLibraryVideoContext();

	if (!data) {
		return null;
	}

	const { src, aspectRatio } = data;

	const hasLibraryVideo =
		data.provider === RESOURCE_VIDEO_PROVIDERS.LIBRARY &&
		Boolean(data.video_id);
	const hasURLVideo =
		data.provider === RESOURCE_VIDEO_PROVIDERS.URL &&
		isSafeUrl(data.src);

	return (
		<div>
			{showTitle &&
				<span className="title">
					<h5 style={{ margin: 0 }}>
						{title}
					</h5>
				</span>
			}
			{hasLibraryVideo && !isLoading &&
				<LibraryVideo
					video={video}
					title={title}
					contentType="resource"
					error={videoError}
					isAdmin={isAdmin}
					aspectRatio={aspectRatio}
					orgDomain={window.location.hostname}
					viewerUserId={userId}
					autoplay={false} // Explicitly set autoplay to false for static pages
					onVideoWatch={onVideoWatch} />
			}
			{hasURLVideo &&
				<VideoFeed
					id={id}
					src={src}
					aspectRatio={aspectRatio}
					onVideoWatch={onVideoWatch} />
			}
		</div>
	);

};

ContentDisplay.propTypes = propTypes;

export default ContentDisplay;
